import * as React from "react"

const ChevronRight = (props: any) => (
    <svg width={16} height={16} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
            d="M6.193 4.473c-.26.26-.26.68 0 .94L8.78 8l-2.587 2.586a.664.664 0 1 0 .94.94l3.06-3.06c.26-.26.26-.68 0-.94l-3.06-3.06a.67.67 0 0 0-.94.007Z"
            fill="#2BB792"
        />
    </svg>
)

export default ChevronRight
